import { mergeSx } from "@/utils";

import { useFetchLogoContent } from "@/hooks/useFetchLogoContent";
import type { NestedLogoComponentProps } from "@/types";

import { SvgIcon } from "../SvgIcon";

export function HubHorizontalLockupCompact({
  sx,
  testId,
  ...props
}: NestedLogoComponentProps) {
  const svgContent = useFetchLogoContent("HubHorizontalLockupCompact");
  return (
    <SvgIcon
      {...props}
      testId={testId}
      viewBox="0 0 115 48"
      sx={mergeSx({ w: "200px", fill: "base.color.brand.1" }, sx)}
    >
      {svgContent && (
        <g
          data-testid={`${testId}__g`}
          dangerouslySetInnerHTML={{ __html: svgContent?.join?.("") }}
        />
      )}
    </SvgIcon>
  );
}
HubHorizontalLockupCompact.displayName = "HubHorizontalLockupCompact";
